var _defs, _rect, _g, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_13_1",
    "data-name": "Component 13 \\u2013 1",
    width: 122,
    height: 36,
    viewBox: "0 0 122 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    y1: 6.614,
    x2: -0.383,
    y2: 5.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    y1: 17.098,
    x2: -1.305,
    y2: 17.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    y1: 10.863,
    x2: -0.501,
    y2: 9.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: 13.583,
    x2: 0.421,
    y2: 12.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    width: 122,
    height: 36,
    rx: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(37.555 5.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M56.806,19.9a2.435,2.435,0,0,1-.67,1.8,2.615,2.615,0,0,1-1.982.8,2.835,2.835,0,0,1-1.985-4.826,2.714,2.714,0,0,1,1.985-.81,2.793,2.793,0,0,1,1.108.226,2.219,2.219,0,0,1,.843.6l-.474.474a1.825,1.825,0,0,0-1.477-.639,2.185,2.185,0,0,0-1.473,3.71,2.149,2.149,0,0,0,2.98,0,1.7,1.7,0,0,0,.452-1.093H54.155V19.5H56.77A2.3,2.3,0,0,1,56.806,19.9Z",
    transform: "translate(-51.352 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M61.675,17.663H59.217v1.711h2.216v.647H59.217v1.711h2.457V22.4h-3.15V17h3.15Z",
    transform: "translate(-52.075 -16.88)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M65.032,22.4h-.694V17.663H62.832V17h3.707v.663H65.032Z",
    transform: "translate(-52.509 -16.88)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M69.938,22.4V17h.692v5.4Z",
    transform: "translate(-53.226 -16.88)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M73.881,22.4h-.693V17.663H71.681V17h3.707v.663H73.881Z",
    transform: "translate(-53.402 -16.88)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M83.076,21.685a2.8,2.8,0,0,1-3.955,0,2.915,2.915,0,0,1,0-4,2.793,2.793,0,0,1,3.952,0,2.906,2.906,0,0,1,0,4Zm-3.444-.452a2.075,2.075,0,0,0,2.931,0,2.3,2.3,0,0,0,0-3.1,2.075,2.075,0,0,0-2.931,0,2.3,2.3,0,0,0,0,3.1Z",
    transform: "translate(-54.072 -16.866)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M85.575,22.4V17h.844l2.622,4.2h.03l-.03-1.039V17h.693v5.4h-.723l-2.743-4.4h-.03l.03,1.04V22.4Z",
    transform: "translate(-54.803 -16.88)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M75.4,31.278A3.824,3.824,0,1,0,79.243,35.1,3.769,3.769,0,0,0,75.4,31.278Zm0,6.141A2.324,2.324,0,1,1,77.562,35.1,2.212,2.212,0,0,1,75.4,37.419ZM67.03,31.278A3.824,3.824,0,1,0,70.869,35.1,3.769,3.769,0,0,0,67.03,31.278Zm0,6.141A2.324,2.324,0,1,1,69.188,35.1,2.212,2.212,0,0,1,67.03,37.419Zm-9.962-4.968v1.622H60.95a3.386,3.386,0,0,1-.883,2.042,3.975,3.975,0,0,1-3,1.188,4.317,4.317,0,0,1,0-8.633,4.136,4.136,0,0,1,2.926,1.159l1.145-1.145a5.661,5.661,0,0,0-4.071-1.637,5.94,5.94,0,1,0,0,11.879,5.427,5.427,0,0,0,4.142-1.666,5.361,5.361,0,0,0,1.405-3.8,5.241,5.241,0,0,0-.087-1.013Zm40.74,1.26a3.554,3.554,0,0,0-3.274-2.433A3.634,3.634,0,0,0,90.927,35.1a3.742,3.742,0,0,0,3.8,3.824,3.8,3.8,0,0,0,3.187-1.695l-1.3-.869a2.185,2.185,0,0,1-1.883,1.057,1.947,1.947,0,0,1-1.855-1.158l5.114-2.116Zm-5.215,1.275a2.1,2.1,0,0,1,2-2.231,1.479,1.479,0,0,1,1.42.811Zm-4.157,3.708h1.68V27.453h-1.68Zm-2.753-6.562h-.058a2.651,2.651,0,0,0-2.013-.854,3.828,3.828,0,0,0,0,7.648,2.605,2.605,0,0,0,2.013-.869h.058v.551c0,1.463-.781,2.245-2.042,2.245a2.116,2.116,0,0,1-1.927-1.362l-1.463.609a3.644,3.644,0,0,0,3.39,2.26c1.97,0,3.636-1.159,3.636-3.983V31.509H85.683Zm-1.926,5.287a2.326,2.326,0,0,1,0-4.635,2.336,2.336,0,0,1,0,4.635Zm21.923-9.966h-4.02V38.694h1.677V34.435h2.343a3.5,3.5,0,1,0,0-6.982Zm.043,5.418h-2.386V29.018h2.386a1.927,1.927,0,1,1,0,3.853Zm10.369-1.614a3.152,3.152,0,0,0-2.994,1.72l1.49.622a1.589,1.589,0,0,1,1.533-.825,1.615,1.615,0,0,1,1.764,1.447v.115a3.711,3.711,0,0,0-1.75-.433c-1.605,0-3.24.882-3.24,2.53a2.6,2.6,0,0,0,2.791,2.474,2.367,2.367,0,0,0,2.141-1.1h.058v.868H119.5v-4.31C119.5,32.37,118.015,31.257,116.092,31.257Zm-.2,6.16c-.55,0-1.316-.274-1.316-.954,0-.868.954-1.2,1.779-1.2a2.993,2.993,0,0,1,1.533.376A2.034,2.034,0,0,1,115.889,37.417ZM125.4,31.5l-1.923,4.874h-.058l-2-4.874H119.62l2.993,6.811L120.907,42.1h1.75l4.614-10.6Zm-15.112,7.192h1.678V27.453h-1.678Z",
    transform: "translate(-13.767 -11.921)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222",
    transform: "translate(9.339 6.218)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M20.388,17.531a1.8,1.8,0,0,0-.415,1.263V38.68a1.8,1.8,0,0,0,.415,1.263l.067.065,11.14-11.14v-.263L20.455,17.465Z",
    transform: "translate(-19.973 -17.173)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M36.612,33.416,32.9,29.7v-.263l3.714-3.714.084.049,4.4,2.5c1.256.714,1.256,1.882,0,2.6l-4.4,2.5Z",
    transform: "translate(-21.276 -18.006)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M35.439,33.8l-3.8-3.8L20.435,41.207a1.463,1.463,0,0,0,1.869.055L35.439,33.8",
    transform: "translate(-20.02 -18.437)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M35.439,24.906,22.3,17.443a1.463,1.463,0,0,0-1.869.055L31.641,28.7Z",
    transform: "translate(-20.02 -17.14)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(0 15.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M35.356,34.132,22.3,41.547a1.5,1.5,0,0,1-1.8.01h0l-.067.067h0l.067.066h0a1.5,1.5,0,0,0,1.8-.01l13.135-7.463Z",
    transform: "translate(-20.02 -34.132)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M20.388,42.176a1.8,1.8,0,0,1-.415-1.263v.132a1.8,1.8,0,0,0,.415,1.262l.067-.067Z",
    transform: "translate(-19.973 -34.816)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M41.512,31.168l-4.483,2.547.084.084,4.4-2.5a1.578,1.578,0,0,0,.942-1.3h0A1.673,1.673,0,0,1,41.512,31.168Z",
    transform: "translate(-21.693 -18.437)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M22.258,17.574l17.535,9.963a1.673,1.673,0,0,1,.942,1.167h0a1.576,1.576,0,0,0-.942-1.3L22.258,17.443c-1.257-.714-2.285-.12-2.285,1.318v.132C19.973,17.454,21,16.86,22.258,17.574Z",
    transform: "translate(-19.973 -17.14)",
    fill: "#fff",
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/googlePlay.7292b843.svg";
export { ForwardRef as ReactComponent };